import { TRequestorFillForm } from '../models'

export const getInitialRequestorFillForm = (): TRequestorFillForm => ({
  EntryId: 0,
  BusinessUnit: null,
  Category: null,
  Completeness: 0,
  HPSigningEntity: null,
  LeadBU: null,
  Reason: null,
  ReqEmail: null,
  ReqFullName: null,
  RequestId: 0,
  TerritorySale: [],
  TerritorySaleISO: [],
  ZYME: null,
  DealValue: null,
  DealMargin: null,
  WinProbability: null,
  SalesStage: null,
  BigDealEnablement: null,
})
